import React from 'react';
import FamilyMember from 'modules/family/components/family-member-table/family-member';
import { inject, observer } from 'mobx-react';

const FamilyMembers = ({store}) => {
    const members = store.family.familyMembers;

    if (members.length === 0) {
        return null;
    }

    return members.map(member => <FamilyMember key={member.id} member={member} />)
};

export default inject('store')(observer(FamilyMembers));


// WEBPACK FOOTER //
// ./src/modules/family/components/family-member-table/family-members.js